import { render, staticRenderFns } from "./adminschool.vue?vue&type=template&id=56e42f7c&scoped=true"
import script from "./adminschool.vue?vue&type=script&lang=js"
export * from "./adminschool.vue?vue&type=script&lang=js"
import style0 from "./adminschool.vue?vue&type=style&index=0&id=56e42f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e42f7c",
  null
  
)

export default component.exports